import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import LocationSelector from '~/javascript/components/admin/location_selector/LocationSelector.vue'

export default class extends Controller {
  static values = {
    websiteId: String,
    csrf: String,
    citiesUrl: String,
    createUrl: String
  }

  connect() {
    console.log('[LocationSelector] Stimulus controller connected')

    // Create Vue app and mount it
    this.vueApp = createApp(LocationSelector, {
      websiteId: this.websiteIdValue,
      citiesApiUrl: this.citiesUrlValue,
      createUrl: this.createUrlValue,
      csrfToken: this.csrfValue,
      onCancel: () => this.handleCancel(),
      onSuccess: (data) => this.handleSuccess(data)
    })

    this.vueApp.mount(this.element)
  }

  disconnect() {
    if (this.vueApp) {
      this.vueApp.unmount()
    }
  }

  handleCancel() {
    // Toggle the location selector off
    const selector = document.getElementById('location-selector')
    const btn = document.getElementById('add-locations-btn')
    if (selector) {
      selector.classList.add('hidden')
      if (btn) {
        btn.innerHTML = '<svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg> Add Locations'
      }
    }
  }

  handleSuccess(data) {
    console.log('[LocationSelector] Success:', data)
    // Page will reload automatically from Vue component
  }
}
